import React from "react";
import { Intent } from "@blueprintjs/core";
import { AppToaster } from "app/toaster";

export const API = "@app/API";

export const createJsonHeaders = content => {
  const headers = new Headers({ Accept: "application/json" });
  if (content) {
    headers.append("Content-Type", "application/json");
    headers.append("Content-Length", content.length.toString());
  }
  return headers;
};

export const createTextHeaders = content => {
  const headers = new Headers({ Accept: "application/json" });
  if (content) {
    headers.append("Content-Type", "text/plain");
    headers.append("Content-Length", content.length.toString());
  }
  return headers;
};

const setState = (type, info) => ({
  type,
  ...info
});

const showErrorToast = info => {
  const { request, data } = info;
  const toast = {
    iconName: "error",
    message: (
      <span>
        API error: {data.message}
        <br />
        Request: {request.method} {request.url}
      </span>
    ),
    intent: Intent.DANGER,
    timeout: 8000
  };
  AppToaster.show(toast);
};

export const apiMiddleware = store => next => action => {
  const { getState, dispatch } = store;
  if (action.type !== API) {
    return next(action);
  }
  action.ui = { showToastOnError: true, ...action.ui };
  const { request, PENDING, ERROR, SUCCESS, ...payload } = action.payload;
  const { token } = getState().auth;
  if (token) {
    request.headers.append("Authorization", `Bearer ${token}`);
  }
  dispatch(setState(PENDING, { request, payload }));
  return fetch(request)
    .then(response => {
      const contentType = response.headers.get("Content-Type");
      const isJson = /^application\/json/.test(contentType);
      if (!isJson && response.ok) {
        throw new TypeError(`Expected JSON content type, got "${contentType}"`);
      } else if (isJson) {
        return response
          .json()
          .then(data => {
            if (response.ok) {
              return setState(SUCCESS, { request, response, data, payload });
            } else {
              throw setState(ERROR, { request, response, data, payload });
            }
          })
          .catch(error => {
            throw error;
          });
      } else {
        throw new Error(`${response.status} ${response.statusText}`);
      }
    })
    .then(action => {
      dispatch(action);
      if (action.payload.actionCreators) {
        action.payload.actionCreators.forEach(create =>
          dispatch(create(action))
        );
      }
      return action;
    })
    .catch(error => {
      if (error.type === ERROR) {
        dispatch(error);
      } else {
        const info = { request, data: { message: error.message }, payload };
        dispatch(setState(ERROR, info));
        if (error instanceof Error && action.ui.showToastOnError) {
          console.error(error);
          showErrorToast(info);
        } else {
          throw error;
        }
      }
    });
};



// WEBPACK FOOTER //
// ./src/app/api.js